module.exports = __webpack_public_path__ + "img/809.ba42f57d.png";